export default[
    {
        path: '/rayosx',
        component: () => import(/* webpackChunkName: "rayosx" */ '@/views/RayosX.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_PACIENTES'],
        },
        children:[
            {
                path:'/',
                name:'rayosXMain',
                component: () => import(/* webpackChunkName: "rayosXMain" */ '@/views/rayosx/RayosXList.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'estudio/:id',
                name:'rayosXDetalle',
                component: () => import(/* webpackChunkName: "rayosXDetalle" */ '@/views/rayosx/RayosXEstudio.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'create',
                name:'rayosXNuevo',
                component: () => import(/* webpackChunkName: "rayosXNuevo" */ '@/views/rayosx/RayosXNuevo.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
        ],
    }
]